module.exports = __webpack_public_path__ + "img/city_taipei.4a31f3f8.png";